import React, { useEffect } from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { useModal } from '../../../hooks/useModal';
import Scrollbar from 'react-scrollbars-custom';
import { compilationScrollbarSettings } from '../../../constants/copyright';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import classNames from 'classnames';
import { safeHTML } from '../../../utils/safeHTML';
import { GTMQuizCopyPromo } from '../../../constants/analytics/GTM';
import { useCopy } from '../../../hooks/useCopy';
import { useOpen } from '../../../hooks/useOpen';
import { useProducts } from '../../../redux/reducer/content';
import Product from '../../features/product';
import { image } from '../../../utils/data/baseUrl';
import { useRequestsHandlerData } from '../../../hooks/useRequestsHandlerData';
import AppLoader from '../../features/appLoader/AppLoader';
import useStateControls from '../../../hooks/useStateControls';
import { useTranslation } from '../../../translations';
import { useApplicationCallbacks } from '../../../providers/application-callbacks';
import useGetProductsAndClear from '../../features/product/model/hooks/useGetProductsAndClear';

const AdminCustomModal = React.forwardRef(
  (
    {
      buttons,
      productsId,
      promocodeData,
      title,
      description,
      image: img,
      id: modalId,
      redirect,
      onShow, // событие при показе модального окна
    },
    ref,
  ) => {
    const { buyProducts, productsFromGA } = useProducts();
    const { title: promocodeTitle, promocode, rules, description: promoDescription, type } = promocodeData ?? {};
    const [getProducts, isPendingProducts] = useGetProductsAndClear();
    const { t } = useTranslation();

    const callbacks = useApplicationCallbacks();
    const { closeModal, id } = useModal();
    const openLink = useOpen();
    const { setState } = useStateControls();
    const [text, copy, isDisabled] = useCopy(promocode);

    const buttonCallbacks = {
      close() {
        closeModal({ id });
      },
      redirect() {
        setState(redirect);
        closeModal({ id });
      },
      toShop({ link }) {
        openLink(link);
        typeof modalId === 'number' && callbacks.openCustomModal(modalId);
      },
      copyPromocode() {
        copy();
        GTMQuizCopyPromo(id);
      },
    };

    useEffect(() => {
      getProducts(
        buyProducts.reduce((acc, { modal_id, sku }) => {
          modal_id === productsId && acc.push(sku);
          return acc;
        }, []),
      );

      onShow?.();
    }, []);

    const isPending = useRequestsHandlerData([
      { address: 'requestsProductToFavorites' },
      { address: 'requestsUserServiceDataSave' },
      { address: 'requestsGameCompleteQuest' },
    ]);

    return (
      <CustomModal animation={['fade', 'scale', 'scale-bounce']}>
        <div className={classNames('quiz-winner-modal')} ref={ref}>
          <div className={'quiz-winner-modal__bg'} />
          <div className={'quiz-winner-modal__content'}>
            <Scrollbar {...compilationScrollbarSettings}>
              {img && (
                <div className={'quiz-winner-modal__image'}>
                  <img src={img} alt={''} />
                </div>
              )}

              <h3 className={'quiz-winner-modal__subtitle'}>
                {safeHTML(type === 'Promocode' ? promocodeTitle : t(title))}
              </h3>

              {promocode && (
                <div className={'quiz-winner-modal__promocode'}>
                  <span>{promocode}</span>
                  <CustomButton
                    disabled={isDisabled}
                    className={'custom-button_min custom-button_copy'}
                    text={text}
                    onClick={buttonCallbacks.copyPromocode}
                  />
                </div>
              )}

              <div className={'promocode-modal__text'}>{safeHTML(description ?? promoDescription)}</div>

              {rules?.attr?.href && <a {...rules.attr}>{safeHTML(rules.text)}</a>}

              {!!productsFromGA?.length && (
                <div className={classNames('quiz-win-modal__more')}>
                  <img src={image('procedureResult/arrow.svg')} className={'procedure-result-modal__arrow'} alt={''} />

                  <div className='procedure-result-modal__selection quiz-win-modal__selection quiz-win-modal__selection_products'>
                    <div className='procedure-result-modal__selection-title'>{t('other.productSelections')}</div>
                    <div className='procedure-result-modal__selection-list quiz-win-modal__selection-list_products'>
                      {productsFromGA.map((item, index) => (
                        <Product key={index} className={'product_quiz product_quiz-gray'} noCode={true} {...item} />
                      ))}
                    </div>
                  </div>
                </div>
              )}

              <div className={'quiz-winner-modal__buttons'}>
                {buttons.map((button) => (
                  <CustomButton
                    key={button.action}
                    {...button.attr}
                    onClick={() => buttonCallbacks[button.action](button)}
                  />
                ))}
              </div>
            </Scrollbar>
          </div>
          {(isPending || isPendingProducts) && <AppLoader />}
        </div>
      </CustomModal>
    );
  },
);

export default AdminCustomModal;
